/**
 * Simple timezone utility
 */

/**
 * Get user's current timezone
 * @returns {string} User's timezone (e.g., "Asia/Kolkata")
 */
export const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};